module.exports = __webpack_public_path__ + "e04fe7fd10eac8090192027a063e1e4e.png";